import { useEffect, useState } from "react";
import client, { paymentClient } from "../../api/client";
import endpoints, { paymentEndpoints } from "../../api/endpoints";
import Modal from "../ui/Modal";

/** Coupon entry + checkout for a paid title. */
const PaymentModal = ({ open, onClose, media, type }) => {
  const [code, setCode] = useState("");
  const [finalPrice, setFinalPrice] = useState(media?.price);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  useEffect(() => setFinalPrice(media?.price), [media?.price]);

  const applyCoupon = async () => {
    try {
      const { data, status } = await paymentClient.post(
        paymentEndpoints.validateCoupon(),
        { type: "video", id: media.id, code }
      );
      if (status === 200 && data.discounted_price !== undefined) {
        setFinalPrice(data.discounted_price);
        setSuccess("تخفیف اعمال شد");
        setError("");
        return;
      }
      setSuccess("");
      setError("کد تخفیف نامعتبر است");
    } catch {
      setSuccess("");
      setError(" کد تخفیف نامعتبر است ویا در این آیتم قابل استفاده نیست");
    }
  };

  const pay = async () => {
    try {
      const { data } = await client.post(endpoints.play(type, media.id), {
        coupon_used: code,
      });
      if (data.payment_url) {
        window.location.href = data.payment_url;
        return;
      }
      setError("لینک پرداخت دریافت نشد");
    } catch (paymentError) {
      console.error("خطا در پرداخت:", paymentError);
      setError("خطا در ارتباط با سرور");
    }
  };

  const discounted = finalPrice < media?.price;

  return (
    <Modal open={open} onClose={onClose} title="پرداخت">
      <div className="p-4">
        <label
          className="mb-2 block text-sm font-bold text-gray-300"
          htmlFor="discountCode"
        >
          کد تخفیف
        </label>
        <div className="flex">
          <input
            id="discountCode"
            type="text"
            value={code}
            onChange={(event) => setCode(event.target.value)}
            className="w-full flex-1 rounded-r-lg border border-gray-700 bg-gray-800 px-3 py-2 leading-tight text-gray-300 shadow focus:outline-none"
          />
          <button
            type="button"
            onClick={applyCoupon}
            className="rounded-l-lg bg-blue-500 px-4 py-2 font-bold text-white transition hover:bg-blue-700"
          >
            اعمال
          </button>
        </div>

        {success && <p className="mt-4 text-green-500">{success}</p>}
        {error && <p className="mt-4 text-red-500">{error}</p>}

        <div className="my-4">
          <span className="mb-2 block text-sm font-bold text-gray-300">
            قیمت نهایی:
          </span>
          <div className="text-xl font-semibold">
            {discounted && (
              <span className="ml-2 text-red-500 line-through">
                {media?.price} تومان
              </span>
            )}
            <span>{finalPrice} تومان</span>
          </div>
        </div>

        <div className="text-left">
          <button
            type="button"
            onClick={pay}
            className="rounded bg-brand px-4 py-2 font-bold text-white transition hover:bg-brand-dark"
          >
            پرداخت
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default PaymentModal;
